var ActionListControlEnum;
(function (ActionListControlEnum) {
    ActionListControlEnum["checkbox"] = "Checkbox";
    ActionListControlEnum["chevron"] = "Chevron";
    ActionListControlEnum["radioButton"] = "RadioButton";
    ActionListControlEnum["switch"] = "Switch";
})(ActionListControlEnum || (ActionListControlEnum = {}));
export default ActionListControlEnum;
//# sourceMappingURL=ActionListControlEnum.js.map